import "cropperjs/dist/cropper.css"
import './js/react/App'
